var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99352 0.166992C2.77352 0.166992 0.166016 2.78033 0.166016 6.00033C0.166016 9.22033 2.77352 11.8337 5.99352 11.8337C9.21935 11.8337 11.8327 9.22033 11.8327 6.00033C11.8327 2.78033 9.21935 0.166992 5.99352 0.166992ZM5.99935 10.667C3.42102 10.667 1.33268 8.57866 1.33268 6.00033C1.33268 3.42199 3.42102 1.33366 5.99935 1.33366C8.57768 1.33366 10.666 3.42199 10.666 6.00033C10.666 8.57866 8.57768 10.667 5.99935 10.667ZM6.29102 3.08366H5.41602V6.58366L8.47852 8.42116L8.91602 7.70366L6.29102 6.14616V3.08366Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e68e2f8e.svg";
export { ForwardRef as ReactComponent };